// extracted by mini-css-extract-plugin
module.exports = {"house":"Logo_house__LX4TX","teardrop":"Logo_teardrop__IXXhv","window":"Logo_window__T_PjG","fadeInOut":"Logo_fadeInOut__yJU4e","shadow":"Logo_shadow__N6AKX"};